import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-solar-loan',
  standalone: true,
  imports: [CommonModule,CarouselModule],
  templateUrl: './solar-loan.component.html',
  styleUrl: './solar-loan.component.scss'
})
export class SolarLoanComponent {
  environment: any = environment;
  public bannerListData: any;
  public pdfListingData: any;
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 600,
    nav: false,
    navText: ['', ''],
    stagePadding: 10,
    margin: 25,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 3,
      },
      768: {
        items: 3,
      },
      1000: {
        items: 3
      },
    },
  };
  constructor(public utils: UtilsService, private metaSvc: MetaMgmtService,   private renderer: Renderer2,
      @Inject(DOCUMENT) private document: Document) {
    let metaData: any = {
      canonicalURL: 'https://www.luminousindia.com/sub-category/solar-loan',
      description: 'Get the solar loan online in India by the leading brand Luminous. The solar power is yours! With Luminous finance. Be in touch today.',
      pageTitle: 'Solar Loan - Get Solar Power Financing Online | Luminous India'
    }
    this.metaSvc.updateMetaTags(metaData);
  }

  ngOnInit(): void {
    this.utils.showLoading();
    this.generateSchema();
    this.bannerListData = [
      {
        bannerName: 'Easy finance Options',
        imageUrl: environment.blobUrl+'/assets/images/solar-loan/Picture1.webp'
      },
      {
        bannerName: 'Easy finance Options with ICICI',
        imageUrl: environment.blobUrl+'/assets/images/solar-loan/Picture2.webp'
      },
      {
        bannerName: 'Easy finance Options with HDFC',
        imageUrl: environment.blobUrl+'/assets/images/solar-loan/Picture3.webp'
      },
      {
        bannerName: 'Easy finance Options',
        imageUrl: environment.blobUrl+'/assets/images/solar-loan/Picture1.webp'
      }
    ]
    this.pdfListingData = [
      {
        pdfName: 'SBI',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/SBI.pdf',
      },
      {
        pdfName: 'SIDBI',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/SIDBI.pdf',
      },
      {
        pdfName: 'Annapurna Finance',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/Annapurna_Finance.pdf',
      },
      {
        pdfName: 'HDFC',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/HDFC.pdf',
      },
      {
        pdfName: 'Credit Fair',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/CreditFair.pdf',
      },
      {
        pdfName: 'Ecofy',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/Ecofy.pdf',
      },
      {
        pdfName: 'ICICI',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/ICICI.pdf',
      },
      {
        pdfName: 'Metafin',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/Metafin.pdf',
      },
      {
        pdfName: 'EFL',
        pdfUrl: environment.blobUrl+'/assets/pdf/solar-loan/EFL.pdf',
      }
    ];
  }

  viewPDF(url: string) {
    window.open(url, '_blank');
  }
 generateSchema(): void {
 
    const videoSchemas = {
        '@type': 'VideoObject',
        name:'Easy Solar Financing',
        description: 'Explore seamless financing options through our partners and embrace a brighter, sustainable future with Luminous Solar Solutions.',
        thumbnailUrl: '',
        uploadDate: "12-12-2024",
        embedUrl:"https://www.youtube.com/embed/twLEjwtKvx4?autoplay=1&rel=0&controls=0&mute=1",
        potentialAction: {
          '@type': 'SeekToAction',
          target: "https://www.youtube.com/embed/twLEjwtKvx4?autoplay=1&rel=0&controls=0&mute=1={seek_to_second_number}",
          'startOffset-input': 'required name=seek_to_second_number'
        }
      }


    const schema = {
      '@context': 'https://schema.org',
      '@graph': videoSchemas
    };

  

    // Create and append the schema script
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema, null, 2);
    this.renderer.appendChild(this.document.body, script);

  }
  videoLoaded(): void {
    this.utils.hideLoading();
  }
}
